import { apiClient } from 'src/lib/apiClient';

export interface UninvoicedPayment {
  id: number;
  amount_gross: number;
  pf_payment_id: string;
  is_test: boolean;
  subscription_id: number | null;
  date_created: string;
  merchant: {
    id: number;
    name: string;
    xero_contact_id: string | null;
  };
}

export interface InvoiceResult {
  paymentId: number;
  status: 'invoiced' | 'reused' | 'failed';
  xero_invoice_id?: string;
  error?: string;
}

const ADMIN_UNINVOICED_URL = 'admin/uninvoiced-payments';

export const uninvoicedPaymentsService = {
  getUninvoiced: async (): Promise<UninvoicedPayment[]> => {
    const response = await apiClient.get(ADMIN_UNINVOICED_URL);
    return response.data;
  },

  // Omit paymentIds to invoice all pending (test payments excluded server-side).
  invoicePayments: async (paymentIds?: number[]): Promise<{ results: InvoiceResult[] }> => {
    const response = await apiClient.post(`${ADMIN_UNINVOICED_URL}/invoice`, paymentIds ? { paymentIds } : {});
    return response.data;
  },
};
